import React from 'react';

import { CallCentreManangementOrganism, CallCentreOrganism } from '@project/components/organisms';

import { decodedToken } from '../../../services';

const CallCentreScreen: React.FC = () => {
  const userRole = decodedToken.getRole();

  if (
    userRole === 'SuperAdministrator' ||
    userRole === 'CallCenterManager' ||
    userRole === 'Finance'
  ) {
    return <CallCentreManangementOrganism />;
  }

  if (userRole === 'CallCenterAgent') {
    return <CallCentreOrganism />;
  }

  return null;
};

export default CallCentreScreen;
